import { Injectable, inject } from '@angular/core';
import { AuthLibService } from '@landg_eap/auth-lib';
import { Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import * as RefNoActions from '../../../store/actions/reference-number.actions';
import * as loggedInDetailActions from '../../../store/actions/loggedin-detail.action';
import { Store } from '@ngrx/store';
import { APP_URL } from '../../constants/url.constants';
import { ConfigLoaderService } from './configLoader.service';
import { LoaderService } from './page-loader.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  authLibService = inject(AuthLibService);
  isLoggedInFlag = new BehaviorSubject<boolean>(false);
  

  constructor(private router: Router, private store: Store,private configLoaderService: ConfigLoaderService, private loaderService: LoaderService) { }

  async redirection() {
    let url = window.location.href;
    let queryString = url.split('?');
    let queryParam = new URLSearchParams((queryString && queryString.length > 0 ? queryString[1] : null));
    this.loaderService.handleSpinnerFlag({ show: false, onlyBackgroundFlag: false, Message: '', opacity: .4 });
    if ((queryParam && queryParam.get('param1') && queryParam.get('param1') === 'retrieveQuote') || this.isAuthenticated()) {
      sessionStorage.setItem('logInClicked', 'Y');
      this.router.navigate(['/home/after-login']);
    } else if (queryParam && queryParam.get('applcationRefNo')) {
      sessionStorage.setItem('logInClicked', 'Y');
      // this.router.navigate(['/apply/clear-to-apply']);
    }
  }

  async isLoggedIn() {
    const isLoggedInFlag = await this.authLibService.hasTokens(this.configLoaderService.configuration.web_oauth_client);
    return isLoggedInFlag ? true : false;
  }

  isAuthenticated() {
    const urlParams = new URLSearchParams(window.location.search);
    const codeAndState = (urlParams.get('code')) && (urlParams.get('state'));
    return codeAndState;
  }

  logout(routerURL?: string) {
    this.store.dispatch(new RefNoActions.RemoveReferenceNumber(0));
    this.store.dispatch(new loggedInDetailActions.RemoveLoggedInDetail(0));
    sessionStorage.setItem('logInClicked', 'N');
    this.authLibService.logout(false, APP_URL.user.logout);
    if (routerURL && routerURL === APP_URL.quote.productQuote) {
        const url = document.location.href.substring(0, document.location.href.indexOf('#') + 1) + APP_URL.user.logout;
        window.open(url, '_self');
        window.location.reload();
    }
  }
}
